module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"empty_message":"아직 구매 후기가 등록되지 않았어요.\\nAI 사이즈 추천 결과를 참고해 보세요."}}')
  delete Component.options._Ctor
}
